<template>
    <div class="auth-flow-page">
        <div class="auth-flow-page__backdrop" aria-hidden="true" />
        <main class="auth-flow-page__main" :style="mainStyle">
            <slot />
        </main>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    /** Override max width for the main column (e.g. terms page). */
    mainMaxWidth?: string
}>()

const mainStyle = computed(() =>
    props.mainMaxWidth ? { maxWidth: props.mainMaxWidth } : undefined,
)
</script>

<style scoped>
.auth-flow-page {
    --auth-page-inset-block: clamp(24px, 8vh, 68px);
    --auth-page-inset-inline: clamp(16px, 4vw, 24px);
    --auth-card-max-width: 709px;

    position: relative;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: var(--auth-page-inset-block) var(--auth-page-inset-inline);
    overflow-x: hidden;
    overflow-y: auto;
}

.auth-flow-page__backdrop {
    position: fixed;
    inset: 0;
    z-index: 0;
    background-image:
        linear-gradient(rgba(0, 0, 0, 0.60), rgba(0, 0, 0, 0.60)),
        url('@/assets/img/ara-bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.auth-flow-page__main {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: var(--auth-card-max-width);
    margin-inline: auto;
}

/* Center card vertically when viewport is taller than the design frame */
@media (min-height: 960px) {
    .auth-flow-page {
        align-items: center;
    }
}
</style>
